import axios from "../../config/axiosConfig";

export const getEnterpriseSubscriptions = async (status) => {
  return await axios
    .get(`/enterprise/get/subscription?status=${status}`)
    .then((res) => res)
    .catch((err) => err);
};